<template>
    <div id="debugproductdescriptionspage">
        <ui5-button @click="$router.push('/debugmenu')">
            {{ trans('pages.debug_product_descriptions.back') }}
        </ui5-button>
        <div class="field">
            <ui5-input
                type="Text"
                :value="productId"
                @input="productId = $event.target.value"
                @keyup.enter="showDescription"
            ></ui5-input>
            <ui5-button @click="showDescription">
                {{ trans('pages.debug_product_descriptions.show_description') }}
            </ui5-button>
        </div>
        <spinner-text v-if="loading">
            {{
                trans('pages.debug_product_descriptions.fetching_description', {
                    productId: productId,
                })
            }}
        </spinner-text>
        <div
            id="result"
            v-else
        >
            {{ description }}
        </div>
    </div>
</template>
<script>
import productApi from './../api/product';
import SpinnerText from './../components/loader/SpinnerText';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: {
        SpinnerText,
    },
    mixins: [localization],
    data() {
        return {
            loading: false,
            productId: '',
            description: null,
        };
    },
    methods: {
        showDescription() {
            this.loading = true;
            productApi
                .descriptionForProduct(this.productId)
                .then((response) => {
                    this.description = response.data.data.description;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.debug_product_descriptions.error_fetching_description'
                        )
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style scoped>
#debugproductdescriptionspage .field {
    display: flex;
    margin-top: 14px;
    column-gap: 10px;
}

#debugproductdescriptionspage #result {
    border: dotted 1px;
    min-height: 40px;
    text-align: center;
    margin-top: 20px;
}
</style>
